import moment from "moment";
import {
  tourItem,
  Dates,
  AdvancedFilters,
  SortCriteria
} from "../WhatsOnHero/types";

export interface nationOption {
  type: string;
  code: string;
  name: string;
}

export interface DateValue {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}

export interface WhatsOnTableProps {
  // Will revist getData type
  loadfilters: Function;
  setLoadingError: (state: boolean) => void;
  filtersLoaded: boolean;
  areNoResults: boolean;
  getData: any;
  tourOptions: tourItem[];
  tourCode: string;
  tournamentSearchResults: {
    totalItems: number;
    items: any[];
  };
  dateSelection: {
    startDate: string;
    endDate: string;
  };
  reset: boolean;
  titleSearchTerm: string;
  // Will revist takeValue type
  takeValue: any;
  setTake: Function;
  dateValue: DateValue;
  setDates: (dates: Dates) => void;
  circuitCode: {
    value: string;
    filtersLoaded: boolean;
  };
  updateCircuit: (circuit: {
    value: string;
    filtersLoaded: boolean;
  }) => void;
  searchNationValue: string;
  updateSearchNationValue: Function;
  setTitleSearchTerm: Function;
  isLoading: boolean;
  setIsLoading: Function;
  isProgressiveLoading: boolean;
  setIsProgressiveLoading: Function;
  loadingError: boolean;
  searchStartDate: string | number | (string | number)[] | null | undefined;
  advancedFilters: AdvancedFilters;
  setAdvancedFilters: (filters: AdvancedFilters) => void;
  hostOptions: HostDetails[];
  setHostOptions: (hosts: HostDetails[]) => void;
  setSortCriteria: (criteria: SortCriteria) => void;
  sortCriteria: SortCriteria;
  results?: boolean;
}

export interface CourtSurface {
  name?: string;
  code: string;
  active: boolean;
}

export interface CourtDoorness {
  code: string;
  active: boolean;
}

export interface dropdownItemSelected {
  label: string;
  value: string | number;
  disabled?: Boolean;
  selected: boolean;
}

export interface NationOrRegionSearchResults {
  name: string;
  code: string;
  type: string;
}

export interface HostDetails {
  name: string;
  code: string;
  type: string;
  active: boolean;
  filteredOut: boolean;
}

export const START_DATE = "startDate";
export type START_DATE = typeof START_DATE;

export const HOST_NATION = "hostNationName";
export type HOST_NATION = typeof HOST_NATION;

export const PRIZE_MONEY = "prizeMoney";
export type PRIZE_MONEY = typeof PRIZE_MONEY;

export const VENUE = "venue";
export type VENUE = typeof VENUE;

export const WINNER = "winner";
export type WINNER = typeof WINNER;

export const RUNNER_UP = "runnerup";
export type RUNNER_UP = typeof RUNNER_UP;

export const ALL = "All";
export type ALL = typeof ALL;
